export type OnLoadMoreResultsProps = (
  engine: string,
  query: string,
  page?: number,
) => void;

export interface Engine {
  displayName?: string;
  errorMessage?: string;
  hasMoreResults?: boolean;
  hasResults?: boolean;
  isSearching?: boolean;
  isLoading?: boolean;
  pro?: boolean;
  poweredBy?: React.ReactElement;
  notSupportedMessage?: React.ReactElement;
}

export interface EngineRegistry {
  [engine: string]: Engine;
}

export interface UseAiAssetGenerationResults {
  engine: Engine;
  renderInitialContent?: React.ReactNode;
  renderErrorMessage?: React.ReactNode;
  renderResults: React.ReactNode;
  selectedImage?: string;
  hasError: boolean;
}

export type ContentTypeStatus = 'PENDING' | 'SUCCESS' | 'FAILURE';

export type AiAssetGenerationEngine = 'textToImage' | 'textToVideo';

export enum TextToImageEngine {
  OPEN_AI = 'textToImage',
  GEMINI = 'gemini',
}

export const isTextToImageEngine = (
  engine: string,
): engine is TextToImageEngine =>
  (Object.values(TextToImageEngine) as string[]).includes(engine);
